@if (shelfDisplayed) {
  <div class="shelf-container">

    <div class="shelf" [class.mobile]="appService.isMobile$ | async" >
      <div class="shelf-header" (click)="goToShelf()" [class.mobile]="appService.isMobile$ | async">
        <div class="title"  [class.mobile]="appService.isMobile$ | async">
          @if(title) {
            <div [@fadeIn]>{{ title }}</div>
          } @else {
            <ion-spinner name="dots"></ion-spinner>
          }
        </div>
        <img src="assets/icon/right-yellow-arrow.svg" alt="" class="arabic-transform" />
      </div>

      @if ((appService.isMobile$ | async) === false) {
        @if (swiper && swiper.activeIndex > 0) {
          <div class="left" [@fadeInOut]>
            <app-button
              [arabicTransformIcon]="true"
              [icon]="'assets/icon/left-arrow-2x-bold.svg'"
              (clicked)="swipeBook(false)"
              [shape]="'circle'"
              [size]="'small'" />
          </div>
        }

        @if (showRightButton) {
          <div class="right" [@fadeInOut]>
            <app-button
              [arabicTransformIcon]="true"
              [icon]="'assets/icon/right-arrow-2x-bold.svg'"
              (clicked)="swipeBook(true)"
              [shape]="'circle'"
              [size]="'small'"
              [isLoading]="isLoadingNewBooks"
              [disabled]="isLoadingNewBooks" />
          </div>
        }
      }

      <div class="swipers-container">
        @if(isLoadingBooks) {
          <div class="placeholder-swiper" [@fadeInOut]>
            <swiper-container appSwiper [config]="placeholderConfiguration" [class.desktop]="(appService.isMobile$ | async) === false" >
              <swiper-slide><app-book-shelf-drawer-cover-image /></swiper-slide>
              <swiper-slide><app-book-shelf-drawer-cover-image /></swiper-slide>
              <swiper-slide><app-book-shelf-drawer-cover-image /></swiper-slide>
              <swiper-slide><app-book-shelf-drawer-cover-image /></swiper-slide>
              <swiper-slide><app-book-shelf-drawer-cover-image /></swiper-slide>
              <swiper-slide><app-book-shelf-drawer-cover-image  /></swiper-slide>
            </swiper-container>
          </div>
        }
          <swiper-container #shelfElement appSwiper [config]="swiperConfiguration" [class.desktop]="(appService.isMobile$ | async) === false">
            @for (book of books; track $index) {
              <swiper-slide data-cy="book-shelf-cover-image-slide" >
                <app-book-shelf-drawer-cover-image [book]="book" [type]="type" />
              </swiper-slide>
            }

          @if (isLoadingNewBooks) {
            <div class="shelf-spinner">
              <ion-spinner name="circular"></ion-spinner>
            </div>
          }

          <!-- Needed in order to display the correct shelf placeholder height -->
          @if (isLoadingBooks) {
            <swiper-slide>
              <app-book-shelf-drawer-cover-image [type]="type"  />
            </swiper-slide>
          }

          @if (type === shelfType.Favorites && books.length === 1) {
            <div class="bean-prompt-container">
              <app-book-shelf-drawer-bean-prompt
                [beanLabel]="'PWA_myFavorites_buddyMessage_findFavorites' | translate"
                [buttonLabel]="'PWA_myFavorites_shelf_CTA_seeMore' | translate"
                (buttonClicked)="goToHome()" />
            </div>
          } @else if (type === shelfType.ContinueReading && books.length === 1) {
            <div class="bean-prompt-container">
              <app-book-shelf-drawer-bean-prompt
                [beanLabel]="'PWA_continueReading_buddyMessage_finishBook' | translate"
                [buttonLabel]="'PWA_continueReading_shelf_CTA_finishBook' | translate"
                (buttonClicked)="goToBook()" />
            </div>
          } @else if (type === shelfType.ReadAgain && books.length === 1) {
            <div class="bean-prompt-container">
              <app-book-shelf-drawer-bean-prompt
                [beanLabel]="'PWA_readItAgain_buddyMessage_readMore' | translate"
                [buttonLabel]="'PWA_readItAgain_shelf_CTA_seeMore' | translate"
                (buttonClicked)="goToHome()" />
            </div>
          }
        </swiper-container>
      </div>
    </div>
  </div>
}
